module.exports = __webpack_public_path__ + "img/banner3_4_kr.82d23cbe.png";